// Structure of the Picky Cats funnel: question/option ids + tip ids, plus EN defaultMessage
// fallbacks. The rendered copy comes from the translation barrels keyed by these ids
// (e.g. picky-cats:question:<id>:prompt); the strings here are only react-intl fallbacks.

import { PickyCatsContent } from 'modules/picky-cats/types';

export const PICKY_CATS_FUNNEL_CONTENT: PickyCatsContent = {
  questions: [
    {
      id: 'bowl-shape',
      prompt: "What shape is your cat's bowl?",
      options: [
        { id: 'deep-narrow', label: 'Deep or narrow' },
        { id: 'wide-shallow', label: 'Wide and shallow' },
        { id: 'not-sure', label: 'Not sure' },
      ],
    },
    {
      id: 'bowl-location',
      prompt: "Where's the food bowl?",
      options: [
        { id: 'near-litter', label: 'Near litter box or trash' },
        { id: 'busy-spot', label: 'In a busy spot' },
        { id: 'quiet-spot', label: 'Quiet and calm spot' },
      ],
    },
    {
      id: 'feeding-frequency',
      prompt: 'How often does your cat eat?',
      options: [
        { id: 'once', label: 'Once a day' },
        { id: 'twice-plus', label: 'Two or more set meals' },
        { id: 'free-feed', label: 'Always available (free feeding)' },
      ],
    },
    {
      id: 'feed-temperature',
      prompt: 'How do you serve the food?',
      options: [
        { id: 'cold', label: 'Straight from the fridge' },
        { id: 'room-temp', label: 'At room temperature' },
        { id: 'warmed', label: 'Slightly warmed up' },
      ],
    },
    {
      id: 'multi-cat',
      prompt: 'Are there other cats in the household?',
      options: [
        { id: 'solo', label: 'Just this one' },
        { id: 'shared-bowl', label: 'Yes, sharing the bowl' },
        { id: 'separate-bowls', label: 'Yes, with separate bowls' },
      ],
    },
  ],
  tips: [
    {
      id: 'bowl',
      icon: 'bowl',
      text: 'Swap to a wide, shallow bowl so whiskers never touch the sides.',
    },
    {
      id: 'location',
      icon: 'location',
      text: 'Move the bowl away from the litter box and busy walkways.',
    },
    {
      id: 'temperature',
      icon: 'temperature',
      text: 'Serve food at room temperature to bring out the aroma.',
    },
  ],
};
